import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class OpenerWatchdogService {
    private readonly _isParentClosed = signal(false);
    readonly isParentClosed = this._isParentClosed.asReadonly();

    private readonly hadOpenerAtInit = !!window.opener;

    check(): void {
        if (this._isParentClosed()) return;
        if (!this.hadOpenerAtInit) return;
        try {
            if (!window.opener || window.opener.closed) {
                this._isParentClosed.set(true);
            }
        } catch {
            this._isParentClosed.set(true);
        }
    }
}
